export enum RentReviewType {
    RentReviewIsGreaterThanOne,
    RentReviewIsEqualToOneOrNA
}